import { mean } from "d3-array";
import { slidingWindow } from "../utils";
import { AwesomeOscillator as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { fastPeriod, slowPeriod } = options;

    // Calculate midpoint (HL/2) for each bar
    const midpoints = data.map((d) => {
      if (!d || d.high === undefined || d.low === undefined) return undefined;
      return (d.high + d.low) / 2;
    });

    // Calculate fast SMA (5 period)
    const fastSMA = slidingWindow()
      .windowSize(fastPeriod)
      .accumulator((values) => mean(values));

    const fastMA = fastSMA(midpoints);

    // Calculate slow SMA (34 period)
    const slowSMA = slidingWindow()
      .windowSize(slowPeriod)
      .accumulator((values) => mean(values));

    const slowMA = slowSMA(midpoints);

    // Calculate Awesome Oscillator: fast MA - slow MA
    const ao = fastMA.map((fast, i) => {
      const slow = slowMA[i];
      if (fast === undefined || slow === undefined) return undefined;
      return fast - slow;
    });

    // Add direction flag for coloring bars
    return ao.map((value, i) => {
      if (value === undefined) return undefined;

      const prevValue = i > 0 ? ao[i - 1] : undefined;
      let direction = "up";

      if (prevValue !== undefined) {
        direction = value >= prevValue ? "up" : "down";
      }

      return {
        value,
        direction,
      };
    });
  }

  calculator.undefinedLength = function () {
    const { slowPeriod } = options;
    return slowPeriod - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
